import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/login/logo-mark.webp")